import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Slide,
  IconButton,
  Stack,
  Paper
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { addUserBonus } from '../util/db';
import { useAuth } from '../util/auth';
import { useSnackbar } from 'notistack';
import { serverTimestamp } from 'firebase/firestore';
import { useQueryClient } from 'react-query';
import { startBonusTracking } from '../util/firebase';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function StartBonusModal({ open, onClose, bank, onSuccess }) {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const startDate = new Date();
  const expectedCompletionDate = new Date(startDate.getTime() + (bank?.timeframe * 24 * 60 * 60 * 1000));
  const { enqueueSnackbar } = useSnackbar();
  const [isStarting, setIsStarting] = React.useState(false);

  const handleStartTracking = async () => {
    try {
      setIsStarting(true);
      
      const trackingData = await startBonusTracking(auth.user.uid, bank.id);
      
      // Update parent component state
      if (onSuccess) {
        await onSuccess(trackingData);
      }
      
      onClose();
    } catch (error) {
      console.error('Failed to start tracking:', error);
      enqueueSnackbar(error.message || 'Failed to start tracking', { variant: 'error' });
    } finally {
      setIsStarting(false);
    }
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Start Tracking Bonus
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h5" gutterBottom sx={{ color: 'primary.main', fontWeight: 600 }}>
            {bank?.name} - ${bank?.amount} Bonus
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            You're about to start tracking this bonus opportunity.
          </Typography>
          <Stack spacing={2}>
            <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.neutral', borderRadius: 2 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2" color="text.secondary">Start Date</Typography>
                <Typography variant="subtitle1">{startDate.toLocaleDateString()}</Typography>
              </Stack>
            </Paper>
            <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.neutral', borderRadius: 2 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="subtitle2" color="text.secondary">Expected Completion</Typography>
                <Typography variant="subtitle1">
                  {expectedCompletionDate.toLocaleDateString()}
                </Typography>
              </Stack>
            </Paper>
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleStartTracking} variant="contained" disabled={isStarting}>
          {isStarting ? 'Starting...' : 'Start Tracking'}
        </Button>
      </DialogActions>
    </Dialog>
  );
} 